import {
  type DocumentSidebarCategory,
  type DocumentSidebarSection,
} from "@/components/document-sidebar";

export const buildDsdEditorSidebarCategories = (
  sections: string[],
): DocumentSidebarCategory[] => {
  const categoryMap = new Map<string, DocumentSidebarSection[]>();

  for (const sectionName of sections) {
    const categoryLabel = /^\d/.test(sectionName) ? "주석" : "본문";
    const categorySections = categoryMap.get(categoryLabel) ?? [];
    categorySections.push({
      id: sectionName,
      label: sectionName,
      hasChanges: false,
    });
    categoryMap.set(categoryLabel, categorySections);
  }

  return [...categoryMap.entries()].map(([label, categorySections]) => ({
    label,
    sections: categorySections,
  }));
};
